<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-fire mr-2" />Lebur & Pemurnian Emas</h5>
            <hr />

            <b-tabs v-model="activeTab" @input="onTabChange">
                <b-tab title="Lebur">
                    <i class="fa fa-fire" /> Lebur
                </b-tab>
                <b-tab title="Pemurnian">
                    <i class="fa fa-flask" /> Pemurnian
                </b-tab>
            </b-tabs>

            <b-row class="mt-3">
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select
                            id="filter-status"
                            v-model="filter.status"
                            :options="optFilterStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="No. Batch">
                        <b-form-input
                            id="filter-no-batch"
                            v-model="filter.no_batch"
                            placeholder="Cari no. batch..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <div class="d-flex flex-nowrap">
                            <b-button
                                id="btn-search"
                                class="d-flex align-items-center flex-nowrap"
                                variant="primary"
                                @click="getItems()"
                            >
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>
                            <b-button
                                class="ml-2"
                                variant="danger"
                                @click="resetFilter"
                            >
                                Reset
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button
                            id="btn-create-batch"
                            variant="success"
                            class="ml-2"
                            @click="promptCreateBatch"
                        >
                            <i class="fa fa-plus mr-2" />Batch Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                id="gold-batch-table"
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data batch.
                </template>
                <template v-slot:cell(batch_number)="row">
                    {{ row.item.batch_number || "--DRAFT--" }}
                    <div class="small text-muted">
                        {{ row.item.warehouse }}
                    </div>
                </template>
                <template v-slot:cell(processed_at)="row">
                    {{ row.item.processed_at ? $helper.parseDate(row.item.processed_at) : "-" }}
                </template>
                <template v-slot:cell(total_items)="row">
                    {{ row.item.total_item }}
                </template>
                <template v-slot:cell(total_weight)="row">
                    {{ row.item.net_weight ? row.item.net_weight.toFixed(2) + " gr" : "-" }}
                </template>
                <template v-slot:cell(total_weight_result)="row">
                    {{ row.item.net_weight_result ? row.item.net_weight_result.toFixed(2) + " gr" : "-" }}
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">
                        {{ getStatusBadge(row.item.status)[1] }}
                    </b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link
                        v-if="row.item.status == 1"
                        :to="'/emas/gold-batches/draft/' + row.item.id"
                    >
                        <b-button
                            id="btn-edit-draft"
                            size="sm"
                            variant="success"
                            v-b-tooltip.hover.top
                            title="Lanjut Draft"
                        >
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link
                        v-if="row.item.status == 2"
                        :to="'/emas/gold-batches/' + row.item.id"
                    >
                        <b-button
                            id="btn-view-detail"
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail Batch"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <b-modal
            id="m-create-batch"
            :title="createModalTitle"
            centered
            no-close-on-backdrop
            hide-footer
        >
            <b-form-group label="Pilih Gudang (Divisi Emas)">
                <multiselect
                    id="input-warehouse"
                    v-model="input.warehouse"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optWarehouse"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    id="btn-create-new-batch"
                    variant="primary"
                    :disabled="isSubmitting || input.warehouse == null"
                    @click="createBatch"
                >
                    {{ isSubmitting ? "Membuat..." : "Buat Batch" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            activeTab: 0,

            filter: {
                status: -1,
                no_batch: ""
            },

            input: {
                warehouse: null
            },

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Draft" },
                { value: 2, text: "Selesai" }
            ],

            optWarehouse: [],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "batch_number", label: "No. Batch", sortable: false },
                { key: "processed_at", label: "Tgl. Proses", sortable: false },
                { key: "total_items", label: "Total Items", sortable: false },
                { key: "total_weight", label: "Total Berat", sortable: false },
                { key: "total_weight_result", label: "Total Berat Hasil", sortable: false },
                { key: "status", label: "Status", sortable: false },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0
        };
    },

    computed: {
        currentType() {
            return this.activeTab === 0 ? 1 : 2;
        },
        createModalTitle() {
            return this.currentType === 1 ? "Batch Lebur Baru" : "Batch Pemurnian Baru";
        }
    },

    methods: {
        init() {
            this.initStatus = 0;

            let getItems = this.getItems();

            let getWarehouses = this.$axios
                .get("master/warehouse/selection")
                .then(res => {
                    this.optWarehouse = res.data.data
                        .map(it => ({
                            id: it.id,
                            name: it.name + " - " + it.office_name
                        }));
                });

            Promise.all([getItems, getWarehouses])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            param += "&type=" + this.currentType;

            if (this.filter.status != -1) {
                param += "&status=" + this.filter.status;
            }

            if (this.filter.no_batch) {
                param += "&no_batch=" + encodeURIComponent(this.filter.no_batch);
            }

            return this.$axios
                .get("gold-batches" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onTabChange() {
            this.filter.status = -1;
            this.filter.no_batch = "";
            this.getItems();
        },

        resetFilter() {
            this.filter = {
                status: -1,
                no_batch: ""
            };
            this.getItems();
        },

        promptCreateBatch() {
            this.input.warehouse = null;
            this.$bvModal.show("m-create-batch");
        },

        createBatch() {
            if (this.input.warehouse == null) {
                return this.$helper.toastError(this, "Mohon memilih gudang!");
            }

            this.isSubmitting = true;
            let payload = {
                warehouse_id: this.input.warehouse.id,
                type: this.currentType
            };

            this.$axios
                .post("gold-batches", payload)
                .then(res => {
                    let data = res.data.data;
                    this.$bvModal.hide("m-create-batch");
                    this.$router.push({ path: "/emas/gold-batches/draft/" + data.id });
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        getStatusBadge(status) {
            switch (status) {
                case 1:
                    return ["dark", "DRAFT"];
                case 2:
                    return ["success", "SELESAI"];
                default:
                    return ["light", "-"];
            }
        },
    },

    created() {
        this.init();
        this.$helper.toastFlash(this);
    }
};
</script>
